import { MILESTONES } from './constants';

export function getStreakEmoji(streak) {
  if (streak >= 365) return '🎯';
  if (streak >= 200) return '👑';
  if (streak >= 100) return '💎';
  if (streak >= 50) return '🏆';
  if (streak >= 30) return '⭐';
  if (streak >= 21) return '🌟';
  if (streak >= 14) return '🔥🔥';
  if (streak >= 7) return '🔥';
  if (streak >= 3) return '✨';
  return '';
}

export function getNextMilestone(currentStreak) {
  return MILESTONES.find((m) => m.days > currentStreak) || null;
}

export function getMilestoneProgress(currentStreak) {
  const next = getNextMilestone(currentStreak);
  // Past the final milestone — nothing left to count toward.
  if (!next) {
    const top = MILESTONES[MILESTONES.length - 1];
    return { progress: 100, next: null, daysToGo: 0, maxed: true, top };
  }
  const prev = MILESTONES.filter((m) => m.days <= currentStreak).pop();
  const start = prev ? prev.days : 0;
  return {
    progress: ((currentStreak - start) / (next.days - start)) * 100,
    next,
    daysToGo: next.days - currentStreak,
    maxed: false,
  };
}

export function getMomentumColor(score) {
  if (score >= 80) return '#22C55E'; // Green — On Fire
  if (score >= 60) return '#EAB308'; // Gold — Strong
  if (score >= 40) return '#F97316'; // Orange — Building
  return '#6366F1';                  // Indigo — Getting Started (encouraging, not alarming)
}

export function getMomentumLabel(score) {
  if (score >= 80) return 'On Fire';
  if (score >= 60) return 'Strong';
  if (score >= 40) return 'Building';
  return 'Getting Started';
}

export function getMomentumSubtext(score) {
  if (score >= 80) return "You're crushing it — keep the fire going!";
  if (score >= 60) return 'Great consistency. Stay the course.';
  if (score >= 40) return "You're building real momentum.";
  return 'Check in today to build your streak!';
}
